import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#ACB8C3"
      d="M108.566 65.87a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M104.814 83.855a1.5 1.5 0 0 1 0 2.122l-9.993 9.994a1.5 1.5 0 1 1-2.122-2.122l9.993-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M92.7 83.855a1.5 1.5 0 0 1 2.12 0l9.994 9.994a1.501 1.501 0 0 1-2.122 2.122l-9.993-9.994a1.5 1.5 0 0 1 0-2.122"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="M6.566 33.146a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M101.567 0a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V1.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M93 8.567a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H94.5a1.5 1.5 0 0 1-1.5-1.5M19.874 88.492a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#8F9BA8"
      d="M63.5 77A31.1 31.1 0 0 0 69 93H47a31.1 31.1 0 0 0 5.5-16"
    />
    <path
      fill="#ACB8C3"
      d="M18 72.079c0 2.906 2.388 5.261 5.333 5.261h69.334c2.945 0 5.333-2.356 5.333-5.261v-9.89H18z"
    />
    <path
      fill="#C7D0D9"
      d="M92.667 16.734H23.333c-2.945 0-5.333 2.355-5.333 5.26V62.19h80V21.995c0-2.906-2.388-5.261-5.333-5.261"
    />
    <path
      fill="#ACB8C3"
      fillRule="evenodd"
      d="M34 37.25c0-1.243.99-2.25 2.21-2.25h43.58c1.22 0 2.21 1.007 2.21 2.25s-.99 2.25-2.21 2.25H36.21c-1.22 0-2.21-1.007-2.21-2.25M34 48.25c0-1.243.99-2.25 2.21-2.25h43.58c1.22 0 2.21 1.007 2.21 2.25s-.99 2.25-2.21 2.25H36.21c-1.22 0-2.21-1.007-2.21-2.25"
      clipRule="evenodd"
    />
    <path
      fill="#8F9BA8"
      d="M76.16 93H39.84c-1.016 0-1.84.72-1.84 1.61v1.78c0 .89.824 1.61 1.84 1.61h36.32c1.016 0 1.84-.72 1.84-1.61v-1.78c0-.89-.824-1.61-1.84-1.61"
    />
  </svg>
);
const SvgEnrichedIconDesktopGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconDesktopGreyscale);
export default Memo;
